import { render, staticRenderFns } from "./BaseTLInput.vue?vue&type=template&id=550a4cc4&scoped=true&"
import script from "./BaseTLInput.vue?vue&type=script&lang=ts&"
export * from "./BaseTLInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTLInput.vue?vue&type=style&index=0&id=550a4cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550a4cc4",
  null
  
)

export default component.exports